import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import { Container, Nav, Navbar, Col, Row, Offcanvas } from "react-bootstrap";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Buttons } from "../components/Buttons";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { MdOutlineClose } from "react-icons/md";
import Pdf from "./Pdf";
import "../components/Table.css";
import moment from "moment/moment";
import companyId from "../config/companyId";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";

const ProductHistory = [
  "S.NO",
  "Date",
  "Receipt No.",
  "Name",
  "Amount",
  "Status",
];

const SalesInvoice = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};

  // const [show, setShow] = useState(false);
  // const handleShow = () => setShow(true);
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [selectedOption, setSelectedOption] = useState("");
  // const [printrow, setPrintRow] = useState([]);
  // const handleClose = () => {
  //   setShow(false);
  //   setSelectedOption("");
  // };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const [filterData, setFilterData] = useState({
    search_text: "",
    party_name: "",
    party_id: "",
    from_date: "",
    to_date: "",
  });

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
  };

  const handleClearAll = () => {
    setFilterData({
      search_text: "",
      party_name: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const setLabel = (value, field) => {
    const formattedDate = value ? moment(value).format("DD-MM-YYYY") : "";
    setFilterData({
      ...filterData,
      [field]: formattedDate,
    });
  };

  const [partySalesData, setPartySalesData] = useState([]);
  const fetchPartySalesData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log('sales party',responseData);

      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartySalesData();
  }, []);

  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      
      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: filterData.search_text,
            party_name: filterData.party_name,
            party_id: filterData.party_id,
            from_date: filterData.from_date,
            to_date: filterData.to_date,
            bill_no: filterData.bill_no || "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log('invoice data',responseData);

      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterData]);

  const filteredUserData = userData.filter((item) => {
  const searchText = filterData.search_text?.toLowerCase() || "";
  const billNo = item.bill_no?.toLowerCase() || "";
  const receiptNo = item.receipt_no?.toLowerCase() || "";
  const isReceiptMatch = billNo.includes(searchText) || receiptNo.includes(searchText);

  const itemDate = moment(item.bill_date, ["DD-MM-YYYY", "YYYY-MM-DD"]);
const fromDate = filterData.from_date
  ? moment(filterData.from_date, ["DD-MM-YYYY", "YYYY-MM-DD"])
  : null;
const toDate = filterData.to_date
  ? moment(filterData.to_date, ["DD-MM-YYYY", "YYYY-MM-DD"])
  : null;

  let isDateMatch = true;
  if (fromDate && toDate) {
    isDateMatch = itemDate.isBetween(fromDate, toDate, "day", "[]");
  } else if (fromDate) {
    isDateMatch = itemDate.isSameOrAfter(fromDate, "day");
  } else if (toDate) {
    isDateMatch = itemDate.isSameOrBefore(toDate, "day");
  }

  const partyNameFilter = filterData.party_name?.toLowerCase() || "";
  const itemPartyName = item.party_name?.toLowerCase() || "";
  const isPartyMatch = !partyNameFilter || itemPartyName.includes(partyNameFilter);

  return isReceiptMatch && isPartyMatch && isDateMatch;
});

  // const PrintModal = (rowData) => {
  //   setShow(true);
  //   setPrintRow(rowData);
  // };

  // const handleOptionChange = (event) => {
  //   setSelectedOption(event.target.value);
  // };

  // const handleApiCall = (printrow, selectedOption) => {
  //   openPrintView(printrow, selectedOption);
  // };

  // const openPrintView = async (printrow, type) => {
  //   console.log("printrow", printrow);
  //   const documents = [];
  //   if (type === "Original" || type === "Duplicate" || type === "Triplicate") {
  //     const originalBlob = await pdf(
  //       <Pdf data={printrow} type="Original" />
  //     ).toBlob();
  //     documents.push({
  //       url: URL.createObjectURL(originalBlob),
  //       type: "Original",
  //     });
  //   }
  //   if (type === "Duplicate" || type === "Triplicate") {
  //     const duplicateBlob = await pdf(
  //       <Pdf data={printrow} type="Duplicate" />
  //     ).toBlob();
  //     documents.push({
  //       url: URL.createObjectURL(duplicateBlob),
  //       type: "Duplicate",
  //     });
  //   }
  //   if (type === "Triplicate") {
  //     const triplicateBlob = await pdf(
  //       <Pdf data={printrow} type="Triplicate" />
  //     ).toBlob();
  //     documents.push({
  //       url: URL.createObjectURL(triplicateBlob),
  //       type: "Triplicate",
  //     });
  //   }

  //   documents.forEach((doc) => {
  //     const printWindow = window.open(doc.url, "_blank");
  //     printWindow.onload = () => {
  //       printWindow.print();
  //       URL.revokeObjectURL(doc.url);
  //     };
  //   });
  // };

  // useEffect(() => {
  //   if (selectedOption !== "") {
  //     handleApiCall(printrow, selectedOption);
  //   }
  // }, [selectedOption, printrow]);

  const handleSalesInvoicePrintClick = async (rowData) => {
    try {
      const blob = await pdf(<Pdf data={rowData} type="Original" />).toBlob();
      const url = URL.createObjectURL(blob);
      const printWindow = window.open(url, "_blank");
      printWindow.onload = () => {
        printWindow.print();
        URL.revokeObjectURL(url);
      };
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return <LoadingSpinner message="Loading Sales Invoice..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main px-2 my-3">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle={"Sale Invoice"} />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={showFilter} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Clear</>} onClick={handleClearAll} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle={<>Sales Invoice</>} />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons
                      onClick={closeFilter}
                      lable={<MdOutlineClose />}
                    ></Buttons>
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    key={dropdownKey}
                    labelname={"Search Receipt"}
                    placeholder={"Search Receipt"}
                    name="search_text"
                    value={filterData.search_text}
                    onChange={(e) => handleChange(e, "search_text")}
                  ></TextInputForm>
                </div>
                <div className="py-3">
                  <TextInputForm
                    key={dropdownKey}
                    placeholder={"Party Name"}
                    labelname={"Party Name"}
                    name="party_name"
                    value={filterData.party_name}
                    onChange={(e) => handleChange(e, "party_name")}
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "from_date")}
                        selectedDate={filterData.from_date}
                        calenderlabel="From Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "to_date")}
                        selectedDate={filterData.to_date}
                        calenderlabel="To Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable={"Apply"} onClick={closeFilter}></Buttons>
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable={"Clear"} onClick={clearFilter}></Buttons>
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Container fluid className="px-0">
                <Navbar.Brand>
                  <PageTitle PageTitle={"Transactions"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    <Buttons
                      lable={<>Add New</>}
                      onClick={() => navigate("/console/sales/invoice/create")}
                    />
                  </span>
                </Nav>
              </Container>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll mx-2">
            <TableUI
              headers={ProductHistory}
              body={filteredUserData}
              type="salesinvoice"
              handleEditClick={handleSalesInvoicePrintClick}
              pageview={"yes"}
              onDelete={fetchData}
            ></TableUI>
          </div>
        </div>
      </Container>
      {/* <Modal size="xs" show={show} onHide={handleClose} centered>
        <Modal.Header>
          <PageHead pagehead={<>Print Type</>} onClick={handleClose} />
        </Modal.Header>
        <ModalBody>
          <Container>
            <Row>
              <Col md={4}>
                <input
                  type="radio"
                  id="original"
                  name="fav_language"
                  value="Original"
                  onChange={(e) => handleOptionChange(e)}
                />
                <label htmlFor="original">Original</label>
              </Col>
              <Col md={4}>
                <input
                  type="radio"
                  id="duplicate"
                  name="fav_language"
                  value="Duplicate"
                  onChange={(e) => handleOptionChange(e)}
                />
                <label htmlFor="duplicate">Duplicate</label>
              </Col>
              <Col md={4}>
                <input
                  type="radio"
                  id="triplicate"
                  name="fav_language"
                  value="Triplicate"
                  onChange={(e) => handleOptionChange(e)}
                />
                <label htmlFor="triplicate">Triplicate</label>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal> */}
    </div>
  );
};

export default SalesInvoice;
